import { Link, useLocation } from "react-router-dom";
import { Shield } from "lucide-react";
import SpeakerToggle from "@/components/SpeakerToggle";

const links = [
  { to: "/pricing", label: "Pricing" },
  { to: "/trust-center", label: "Trust" },
  { to: "/legal/privacy", label: "Privacy" },
  { to: "/legal/terms", label: "Terms" },
  { to: "/survey", label: "Survey" },
  { to: "/ai-marketing", label: "Marketing AI" },
];

const HIDE_ON = ["/auth", "/reset-password"];

const SiteFooter = () => {
  const { pathname } = useLocation();
  if (HIDE_ON.some(p => pathname.startsWith(p))) return null;

  const readableText = `The Floor by Horizon. Strategic command interface for elite leaders. Visit pricing, trust center, privacy policy, or take the platform survey.`;

  return (
    <footer className="hidden lg:block border-t border-border bg-background/80 backdrop-blur-md mt-12 pl-56">
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Shield className="w-4 h-4 text-sovereign-gold" />
          <span className="font-mono uppercase tracking-widest">The Floor</span>
          <span>· © {new Date().getFullYear()} Horizon</span>
        </div>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs">
          {links.map(l => (
            <Link key={l.to} to={l.to} className="text-muted-foreground hover:text-foreground transition-colors">
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <span className="text-[10px] text-muted-foreground uppercase tracking-widest">Listen</span>
          <SpeakerToggle text={readableText} />
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
